import { type FC, useState } from 'react';
import Button from '@components/Button';
import Modal from '@components/Modal';

import { DataSourceSelector } from '../components/DataSourceSelector';

interface SyncDataModalProps {
  isOpen: boolean;
  isLoading: boolean;
  onClose: () => void;
  onConfirm: (keepLocal: boolean) => Promise<any>;
}

export const SyncDataModal: FC<SyncDataModalProps> = ({ isOpen, isLoading, onClose, onConfirm }) => {
  const [keepLocal, setKeepLocal] = useState(true);

  const handleConfirm = async () => {
    await onConfirm(keepLocal);
  };

  return (
    <Modal
      className="w-lg"
      onClose={onClose}
      open={isOpen}
      title={
        <div className="flex flex-col items-start gap-2">
          <p className="text-info-900 text-lg leading-6 font-medium">Sync Data with PPL</p>
          <span className="text-info-500 text-sm leading-5 font-normal">
            Push or pull the latest contract data between both platforms
          </span>
        </div>
      }
      titleClassName="text-lg leading-6 font-medium justify-center!"
    >
      <div className="flex flex-col py-4">
        <DataSourceSelector value={keepLocal} onChange={setKeepLocal} />
        <div className="mt-5 flex justify-end gap-2">
          <Button kind="secondary" className="h-[38px]" isDisabled={isLoading} onClick={onClose} size="sm">
            Cancel
          </Button>
          <Button kind="primary" className="h-[38px]" loading={isLoading} size="sm" onClick={handleConfirm}>
            Sync Data
          </Button>
        </div>
      </div>
    </Modal>
  );
};
